import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from '../utils/apiActions/dashboardApi';
import { updatePaymentLocation } from '../redux/slice/paymentLocations';
import { selectPaymentLocation } from '../redux/slice/paymentLocations';
import { updateLocationName } from '../redux/slice/LocationNameSlice';
import { MdRefresh } from "react-icons/md";
const Locations = ({
  sendDataToParent,
  isFullLocation = true,
  flexDirection='row',
}) => {
  const [district, setDistrict] = useState([]);
  const [sector, setSector] = useState([]);
  const [cell, setCell] = useState([]);
  const [village, setVillage] = useState([]);
  const [districtId, setDistrictId] = useState();
  const [sectorId, setSectorId] = useState();
  const [cellId, setCellId] = useState();
  const [sectorName, setSectorName] = useState('')
  const userDetails = localStorage.getItem("user");
  const user = JSON.parse(userDetails);
  const locations = JSON.parse(localStorage.getItem("locations"));
  const selectedPaymentLocations = useSelector(selectPaymentLocation);
  const [cachedLocations, setCachedLocation] = useState(
    selectedPaymentLocations
  );
  const [paymentAddress, setPaymentAddress] = useState(
    cachedLocations.length ? cachedLocations : locations
  );
  const [locationId, setLocationId] = useState(
    cachedLocations.length
      ? cachedLocations[cachedLocations.length - 1].id
      : locations[locations.length - 1].id
  );
  const [locationName, setLocationName] = useState(locations[locations.length -1].name)
  const dispatch = useDispatch();
  const sendData = () => {
    sendDataToParent({
      locationId,
      locationName
    });
  };

  const resetLocation = (length) => {
    switch (length) {
      case 4:
        setVillage([]);
        setLocationId(locations[locations.length - 1].id)
        setLocationName(locations[locations.length - 1].name)
        break;
      case 3:
        setVillage([]);
        setCell([]);
        setLocationId(locations[locations.length - 1].id)
        setLocationName(locations[locations.length - 1].name)
        break;
      case 2:
        setVillage([]);
        setCell([]);
        setSector([]);
        setLocationId(locations[locations.length - 1].id)
        setLocationName(locations[locations.length - 1].name)
        break;
      case 1:
        setVillage([]);
        setCell([]);
        setSector([]);
        setDistrict([]);
        setLocationId(locations[locations.length - 1].id)
        setLocationName(locations[locations.length - 1].name)
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    sendData();
  }, [locationId]);
  const fetchNavigator = useCallback(
    (location, location_id) => {
      const url = `${baseUrl}/locations/${location_id}/sublocations`;
      fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + user.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (location === "district") {
            setDistrict(res);
          } else if (location === "sector") {
            setSector(res);
          } else if (location === "cell") {
            setCell(res);
          } else {
            setVillage(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [locationId]
  );
  useEffect(() => {
    dispatch(updatePaymentLocation(paymentAddress));
  }, [paymentAddress]);
  // update payment address to disply on payment receipt
  const updatePaymentAddress = (e, index) => {
    // Create a copy of the current paymentAddress array
    const updatedPaymentAddress = [...paymentAddress];
    const { options } = e.target;
    const selectedOption = options[options.selectedIndex];
    // Check if the index already has a value
    if (updatedPaymentAddress[index]) {
      // Remove the existing value at the index
      updatedPaymentAddress.splice(index, 1);
    }

    // Insert the new object at the desired index
    updatedPaymentAddress.splice(index, 0, {
      id: e.target.value,
      name: selectedOption.label,
    });

    // Update the state with the modified array
    setPaymentAddress(updatedPaymentAddress);
  };

  const resetLocationPlaceholder = (index) => {
    const updatedCachedLocation = [...cachedLocations];
    if (updatedCachedLocation[index]) {
      updatedCachedLocation.splice(
        index + 1,
        updatedCachedLocation.length - index + 1
      );
      setCachedLocation(updatedCachedLocation);
    }
  };
  const width = {
    width: flexDirection === "column" ? "100%" : "",
  };
  return (
    <div className='locations-container mt-3' style={{ flexDirection }}>
      <div className='location-input' style={width}>
        <select
          className='form-control input-select'
          onClick={() => fetchNavigator("province")}
          onChange={(e) => {
            const { options, value } = e.target;
            setLocationId(value);
            setLocationName(options[options.selectedIndex].label);
          }}
        >
          {!locations[0]?.name && <option>Province</option>}
          {locations[0]?.name ? (
            <option>{locations[0]?.name}</option>
          ) : (
            <>
              {village?.map((el) => (
                <>
                  <option value={el.id} key={el.id}>
                    {el.name}
                  </option>
                </>
              ))}
            </>
          )}
        </select>
      </div>
      <div className='location-input' style={width}>
        <select
          className='form-control input-select'
          onClick={() => {
            if (!locations[1]) {
              fetchNavigator("district", locations[0]?.id);
            }
          }}
          onChange={(e) => {
            const { options } = e.target;
            dispatch(updateLocationName(options[options.selectedIndex].label));
            setLocationId(e.target.value);
            setDistrictId(e.target.value);
            setLocationName(options[options.selectedIndex].label);
            updatePaymentAddress(e, 1);
            resetLocationPlaceholder(1);
            setSector([]);
            setCell([]);
            setVillage([]);
          }}
        >
          {!locations[1]?.name && (
            <option
              value={`${
                cachedLocations.length >= 2 ? cachedLocations[1].id : "0"
              }`}
            >
              {cachedLocations.length > 1
                ? cachedLocations[1].name
                : "District"}
            </option>
          )}
          {district.length > 0 ? (
            <>
              {district?.map((el) => (
                <>
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                </>
              ))}
            </>
          ) : locations[0]?.name ? (
            <option>{locations[1]?.name}</option>
          ) : (
            <option>District</option>
          )}
        </select>
      </div>
      <div className='location-input' style={width}>
        <select
          className='form-control input-select'
          onClick={() => {
            if (!locations[2]) {
              fetchNavigator(
                "sector",
                districtId || cachedLocations[1]?.id || locations[1]?.id
              );
            }
          }}
          onChange={(e) => {
            const { options } = e.target;
            dispatch(updateLocationName(options[options.selectedIndex].label));
            setSectorId(e.target.value);
            setLocationId(e.target.value);
            setLocationName(options[options.selectedIndex].label);
            setSectorName(options[options.selectedIndex].label);
            updatePaymentAddress(e, 2);
            resetLocationPlaceholder(1);
            setCell([]);
            setVillage([]);
          }}
        >
          {!locations[2]?.name && (
            <option
              value={`${
                cachedLocations.length >= 3 ? cachedLocations[2].id : "0"
              }`}
            >
              {cachedLocations.length >= 3 ? cachedLocations[2].name : "Sector"}
            </option>
          )}
          {sector.length > 0 ? (
            <>
              {sector?.map((el) => {
                if (cachedLocations[2]?.name === el.name) return null;
                return (
                  <>
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  </>
                );
              })}
            </>
          ) : (
            <option>{locations[2]?.name}</option>
          )}
        </select>
      </div>
      <div className='location-input' style={width}>
        <select
          className='form-control input-select'
          onClick={() => {
            if (!locations[3]) {
              fetchNavigator(
                "cell",
                sectorId || cachedLocations[2]?.id || locations[2]?.id
              );
            }
          }}
          onChange={(e) => {
            const { options } = e.target;
            dispatch(updateLocationName(options[options.selectedIndex].label));
            setCellId(e.target.value);
            setLocationId(e.target.value);
            if (e.target.value === sectorId) {
              setLocationName(sectorName);
            } else {
              setLocationName(options[options.selectedIndex].label);
            }
            updatePaymentAddress(e, 3);
            resetLocationPlaceholder(3);
            setVillage([]);
          }}
        >
          {!locations[3]?.name && (
            <option
              value={`${
                cachedLocations.length >= 4 ? cachedLocations[3].id : "0"
              }`}
            >
              {cachedLocations.length >= 4 ? cachedLocations[3].name : "Cell"}
            </option>
          )}
          {cell.length > 0 ? (
            <>
              {!isFullLocation && <option value={sectorId}>All</option>}
              {cell?.map((el) => {
                if (cachedLocations[3]?.name === el.name) return null;
                return (
                  <>
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  </>
                );
              })}
            </>
          ) : (
            <option>{locations[3]?.name}</option>
          )}
        </select>
      </div>
      {isFullLocation && (
        <div className='location-input' style={width}>
          <select
            className='form-control input-select'
            onClick={() => {
              if (!locations[4]) {
                fetchNavigator(
                  "village",
                  cellId || cachedLocations[3]?.id || locations[3]?.id
                );
              }
            }}
            onChange={(e) => {
              const { options } = e.target;
              dispatch(
                updateLocationName(options[options.selectedIndex].label)
              );
              setLocationId(e.target.value);
              setLocationName(options[options.selectedIndex].label);
              updatePaymentAddress(e, 4);
            }}
          >
            {!locations[4]?.name && (
              <option
                value={`${
                  cachedLocations.length === 5 ? cachedLocations[4].id : "0"
                }`}
              >
                {cachedLocations.length === 5
                  ? cachedLocations[4].name
                  : "Village"}
              </option>
            )}
            {village.length > 0 ? (
              <>
                {village?.map((el) => {
                  if (cachedLocations[4]?.name === el.name) return null;
                  return (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  );
                })}
              </>
            ) : (
              <option>{locations[4]?.name}</option>
            )}
          </select>
          <div
            className=' mt-1 ml-2 d-flex justify-content-center align-items-center'
            style={{
              width: 50,
              height: 25,
              marginTop: -20,
              border: "1px #124db1 solid",
              borderRadius: 5,
              cursor:"pointer"
            }}
            onClick={() => resetLocation(locations.length)}
            title='Reset location'
          >
            <MdRefresh style={{ color: "#124db1", fontSize: 22 }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Locations